import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { OrgReferral } from "../-components/org-referral";

export const Route = createFileRoute("/_authenticated/org/$orgId/referrals/")({
  component: RouteComponent
});

function RouteComponent() {
  const { org } = useRouteContext({ from: "/_authenticated/org/$orgId/referrals/" });
  return <OrgReferral org={org} />;
}
